export default {
  setSpeciesLoading (state, status) {
    state.speciesLoading = status
  },

  setSpecies (state, species) {
    state.species = species
  },

  removeSpecies (state, speciesId) {
    state.species = state.species.filter(species => species.speciesId !== speciesId)
  },

  setPredefinedSpeciesLoading (state, status) {
    state.predefinedSpeciesLoading = status
  },

  setPredefinedSpecies (state, predefinedSpecies) {
    state.predefinedSpecies = predefinedSpecies
  }
}
